//请自行添加语言资源
const orderLog = {
  orderNo: '订单号',
  orderDate: '订单日期',
  deliveryDate: '要求到达日期',
  poNo: '客户PO号',
  stoOrSo: 'SO或STO号',
  originNo: '发货方编码',
  originName: '发货方名称',
  originAddr: '发货方地址',
  originWh: '发货点',
  soldToPaty: '客配编码',
  destNo: '收货方编码',
  destName: '收货方名称',
  destAddr: '收货方地址',
  destProvince: '收货方省份',
  destCity: '收货方城市',
  originSloc: '发货库位',
  groupSoldTo: '大区',
  hqka: '渠道',
  route: '线路',
  transType: '运输类型',
  transWay: '运输方式',
  originWhType: '常温/冷链',
  totalQty: '总件数',
  totalGrossWeight: '总毛重kg',
  totalVolume: '总体积m3',
  refRdcNo: '参照仓库代码',
  dealStatus: '处理状态',
  dealTime: '处理时间',
  dealResult: '处理结果',
  dealCount: '处理次数',
  createTime: '创建时间',
  detail: {
    itemNo: 'ItemNo',
    skuCode: 'sku编码',
    skuDescription: 'sku描述',
    batch: '批次',
    qty: '数量'
  },
  msg: {}
};
export default orderLog



// WEBPACK FOOTER //
// ./src/page/log/mdlzsct/orderLog/lang/orderLog.zh.js